<template>
  <div>




      <div class="row">
        <div class="col-xs-12">
          <div class="block block-bordered">
            <div class="block block-themed">
            <div class="block-header bg-primary-dark">
                  <ul  class="block-options">

                      <li>
                          <button v-if="deviceSharingEnableFlag" type="button" @click="shareEntity()" ><i class="fa fa-share-alt fa-2x push-15-r "></i></button>
                      </li>

                      <li v-if="flagDisplayDevice===0">
                          <button type="button" @click="toggleDisplayDevice()"><i class="fa fa-angle-double-down fa-2x"></i></button>
                      </li>

                      <li v-if="flagDisplayDevice">
                          <button  type="button" @click="toggleDisplayDevice()"><i class="fa fa-angle-double-up fa-2x"></i></button>
                      </li>
                  </ul>
              <h2 class="block-title" @click="toggleDisplayDevice()"><i class="fa fa-server fa-1x push-5-r "></i>{{tempoBundle.devices[deviceIndex].ReferenceName}}</h2>
            </div>

            <div v-if="flagDisplayDevice" class="block-content">

              <div class="row">
                <div class="col-xs-12">

                    <!-- Section parametre module -->
                    <div class="block">
                        <div class="col-xs-12">
                          <div class="form-group">
                              <label class="col-xs-12">{{ textLabelReferenceName[actualLanguage] }}</label>
                              <div class="col-sm-12">
                                  <input v-model="tempoBundle.devices[deviceIndex].ReferenceName" class="form-control"  placeholder="Entrez votre information">
                              </div>
                          </div>
                        </div>
                        <div class="col-xs-12"><hr></hr></div>


                        <div v-if = "true">
                          <div class="col-xs-12">
                            <div  class="col-xs-12 col-md-8">
                              <div class="form-group">
                                  <label class="col-xs-12 col-md-12">{{ textLabelModuleName[actualLanguage] }}</label>
                                  <div class="col-sm-12">
                                      <input v-model="tempoBundle.devices[deviceIndex].DeviceData.deviceInfo.name" class="form-control" type="test" placeholder="Entrez votre information">
                                  </div>
                              </div>

                              <div class="col-xs-12 col-sm-12">
                                <div class="form-group">
                                    <label class="col-xs-12">{{ textLabelModuleID[actualLanguage] }}</label>
                                    <div class="col-sm-12">
                                        <div class="form-control-static">{{tempoBundle.devices[deviceIndex].DeviceData.deviceId}}</div>
                                    </div>
                                </div>
                              </div>

                              <div class="col-xs-12 col-sm-6">
                                <div class="form-group">
                                    <label class="col-xs-12">{{ textLabelModuleSN[actualLanguage] }}</label>
                                    <div class="col-sm-12">
                                        <div class="form-control-static">{{tempoBundle.devices[deviceIndex].DeviceData.deviceInfo.serialNumber}}</div>
                                    </div>
                                </div>

                              </div>

                            </div>

                              <div  class="col-xs-12 col-md-4">
                                <div class="form-group">
                                  <p><img class = "img-responsive"  width="200px" :src="`organization_img/${tempoBundle.devices[deviceIndex].DeviceData.deviceInfo.devicePicture}` | s3Image"></p>
                                </div>
                              </div>
                          </div>


                          <div class="col-xs-12"><hr></hr></div>

                        </div>
                    </div>
                    <!-- END Section paramètre module -->



                    <div class="row">
                      <div class="col-xs-12">
                        <div class="block">
                          <div class="block block-bordered block-themed">
                            


                              <div class="block-header bg-muted">
                                <ul class="block-options">
                                    <li v-if="flagDisplayMap===0">
                                        <button type="button" @click="togglePlanMap()"><i class="fa fa-angle-double-down fa-2x"></i></button>
                                    </li>
                                    <li v-if="flagDisplayMap">
                                        <button  type="button" @click="togglePlanMap()"><i class="fa fa-angle-double-up fa-2x"></i></button>
                                    </li>
                                </ul>
                                <h2 class="block-title" @click="togglePlanMap()">{{ sectionLabelLocalisation[actualLanguage] }}</h2>
                              </div>
                             

                              <div v-if="flagDisplayMap" class="block-content">
                                <div class="row">
                                  <div class="col-xs-12">
                                    <div class="form-material">
                                      <label>{{ labelFieldDeviceAddress[actualLanguage] }}</label>
                                      <gmap-autocomplete class="form-control" style="width: 100%; margin-bottom: 5px"
                                        @place_changed="usePlace"
                                        :placeholder="locationString">
                                      </gmap-autocomplete>
                                    </div>
                                    <Gmap-Map style="width: 100%; height: 300px;" :zoom="7" :center="center">
                                      <Gmap-Marker v-for="(marker, index) in markers"
                                        :key="index"
                                        :position="marker.position"
                                        :draggable='true'
                                        ></Gmap-Marker>
                                        <!-- @dragEnd="markerDrag" -->
                                      <!-- <Gmap-Marker
                                        v-if="this.place"
                                        :position="{
                                          lat: this.place.geometry.location.lat(),
                                          lng: this.place.geometry.location.lng(),
                                        }"
                                        ></Gmap-Marker> -->
                                    </Gmap-Map>
                                  </div>
                                </div>
                              </div>

                            </div>
                          
                        </div>
                      </div>
                    </div>


            

                    <!-- ================================================================= -->
                    <!-- Secion de configuration des paramètre du module de type API-->
                    <!-- ================================================================= -->

                    <div v-if="deviceConfigViewFlag" class="row">
                      <div class="col-xs-12">
                        <div class="block">
                          <div class="block block-bordered block-themed">
                            <div class="block-header bg-muted">
                              <ul class="block-options">
                                  <li v-if="flagDisplayApiDevConfig===0">
                                      <button type="button" @click="toggleApiDevConfig()"><i class="fa fa-angle-double-down fa-2x"></i></button>
                                  </li>
                                  <li v-if="flagDisplayApiDevConfig">
                                      <button  type="button" @click="toggleApiDevConfig()"><i class="fa fa-angle-double-up fa-2x"></i></button>
                                  </li>
                              </ul>
                              <h2 class="block-title" @click="toggleApiDevConfig()">{{ sectionLabelApiDev[actualLanguage] }}</h2>
                            </div>
                            <div v-if="flagDisplayApiDevConfig" class="block-content">
                              <div class="row"> 
                                <div class="col-xs-12">
                                    <h3 class="font-w300 push-10">{{sectionLabelApiDev[actualLanguage] }}</h3>
                                </div>


                                <div v-for="(parameter,index) in tempoBundle.devices[deviceIndex].DeviceData.apiDeviceConfig.controlParameters" class="col-xs-12 col-md-12">

                                  <div v-if="parameter.flagViewByCustomer  || flagBundleIsDeviceCreatorBundle" class="col-sm-12">
                                    <div class="col-sm-12 col-md-6 col-lg-6">
                                      <h4 class="font-w300 push-10">{{ parameter.parameterLabel[actualLanguage] }}</h4>
                                    </div>


                                    <div v-if="parameter.editViewByCustomer  || flagBundleIsDeviceCreatorBundle" class="col-sm-6 col-md-6 col-lg-3">
                                        <div v-if="parameter.dataType==='Bool'" class="col-sm-12">
                                        <label for="register4-firstname">{{ sectionLabelApiDevCtrlValue[actualLanguage] }}</label>
                                        <input type="checkbox" checked v-model="parameter.dataValue"><span></span>
                                      </div>                                 
                                      <div v-else class="col-sm-12">
                                        <label for="register4-firstname">{{ sectionLabelApiDevCtrlValue[actualLanguage] }}</label>
                                        <input class="form-control  align-center" type="text" v-model="parameter.dataValue" placeholder="Valeur/Value">
                                      </div>
                                    </div>

                                    <div v-if="true" class="col-sm-6 col-md-6 col-lg-3">
                                      <div v-if="parameter.dataType==='Bool'" class="col-sm-12">
                                        <label for="register4-firstname">{{ sectionLabelApiDevCtrlLastValue[actualLanguage] }}</label>
                                        <input type="checkbox" checked v-model="parameter.dataValueLastTransmit"><span></span>
                                      </div>
                                      <div v-else class="col-sm-12">
                                        <label for="register4-firstname">{{ sectionLabelApiDevCtrlLastValue[actualLanguage] }}</label>
                                        <input class="form-control align-center" type="text" v-model="parameter.dataValueLastTransmit" placeholder="Valeur/Value">
                                      </div>
                                    </div>
                                  </div>

                                </div>
                              </div>


                              <div v-if="flagBundleIsDeviceCreatorBundle" class="row"> 
                                <div class="col-xs-12">
                                    <h3 class="font-w300 push-10">Durée de vie</h3>
                                </div>


                                <div class="col-sm-12">
                                  <div class="col-sm-12 col-md-6 col-lg-4">
                                    <label for="register4-firstname">{{ sectionLabelApiDevTTLRaw[actualLanguage] }}</label>
                                    <input class="form-control align-center" type="text" v-model="tempoBundle.devices[deviceIndex].DeviceData.apiDeviceConfig.dataTTL.raw" placeholder="Valeur/Value">
                                  </div>

                                  <div class="col-sm-12 col-md-6 col-lg-4">
                                    <label for="register4-firstname">{{ sectionLabelApiDevTTLHr[actualLanguage] }}</label>
                                    <input class="form-control align-center" type="text" v-model="tempoBundle.devices[deviceIndex].DeviceData.apiDeviceConfig.dataTTL.hr" placeholder="Valeur/Value">
                                  </div>

                                  <div class="col-sm-12 col-md-6 col-lg-4">
                                    <label for="register4-firstname">{{ sectionLabelApiDevTTLRaw[actualLanguage] }}</label>
                                    <input class="form-control align-center" type="text" v-model="tempoBundle.devices[deviceIndex].DeviceData.apiDeviceConfig.dataTTL.day" placeholder="Valeur/Value">
                                  </div>
                                </div>

                              </div>


                            </div>
                          </div>
                        </div>
                      </div>
                    </div>




                    <!-- ================================================================= 
                    <div v-if="deviceConfigViewFlag" class="block">
                      <config-device-plan :deviceIndex="deviceIndex" ></config-device-plan>
                    </div>  
                    -->







                    <div v-if="bundleConfigEditFlag" class="col-sm-12 col-md-12">

                      <div class="col-sm-12 col-md-6">
                        <p><button @click="confirmRemoveDevice()" type="button" class="btn btn-danger align-left" name="button">
                          <spinner size="small" v-if="deviceIsDeleting"></spinner>
                          <span v-else><i class="fa fa-trash fa-1x push-5-r "></i>{{ labelFieldButtonConfirmDeleteDevice[actualLanguage] }}</span></button></p>
                      </div>

                      <div v-if="deviceConfigEditFlag" class="col-sm-12 col-md-6">
                        <p><button @click="saveDeviceModifications()" type="button" class="btn btn-success align-right" name="button">
                          <spinner size="small" v-if="deviceIsSaving"></spinner>
                          <span v-else><i class="fa fa-floppy-o fa-1x push-5-r "></i>{{ labelFieldButtonConfirmSaveDevice[actualLanguage] }}</span></button></p>
                      </div>
                    </div>

                </div>
              </div>

            </div>
        </div>
      </div>
      </div>
    </div>
  </div>


</template>

<script>

import _ from 'underscore'
import {mapState, mapGetters, mapActions} from 'vuex'
import electPlanDef from '@/views/configuration/ElectricalPlanDefinition.js'
import ConfigDevicePlan from './ConfigDevicePlan'
import Spinner from '@/components/Spinner'
import ConfigSharingList from './SubComponent/ConfigSharingList'

export default {
  props: ['deviceIndex'],
  components: {
    Spinner,
    ConfigDevicePlan,
    ConfigSharingList
  },
  data() {
    return {
      tempoBundle : {},
      center: {lat: 46, lng: 71},
      markers: [],
      place: null,
      flagDisplayMap: 0,
      flagDisplayPortCfg : 0,
      flagDisplayDevice : 0,
      flagDisplayApiDevConfig : 0,
      flagBundleIsDeviceCreatorBundle : false,
      deviceIsSaving : false,
      deviceIsDeleting : false,
      displayCloudLiveButton : false,
      flagCloudLiveIsActivating : false,
      electricalPlanDefinitions : electPlanDef,
      locationString : '',

      flagDisplayListOfChannel : 0,
      deviceLinkedChannelIsReading : false,
      deviceListOfLinkedChannel : [],
      
      actualLanguage : "FR",
      flagDisplaySelectPlan : false,
      labelFieldDeviceName: {FR: "Nom de l'appareil", EN: 'Device name'},
      labelFieldDeviceAddress: {FR: "Localisation du module (adresse)", EN: 'Device location (address)'},
      labelFieldTitleBillPlan: {FR: 'Plan de tarification électrique', EN: 'Electrical billing plan'},
      labelApplyButtonBillPlan: {FR: 'Appliquer', EN: 'Apply'},
      labelCancelButtonBillPlan: {FR: 'Annuler', EN: 'Cancel'},
      labelSelectPreRecBillPlan: {FR: 'Sélectionner un plan pré-enregistré', EN: 'Select pre-recorded plan'},
      //labelSelectPlan: {FR: 'Sélectionner un plan', EN: 'Select plan'},
      //labelFieldTitleBasePrice: {FR: 'Tarif de base:', EN: 'Base price:'},
      //labelFieldTitleTarif: {FR: 'Tarif ($/kWh)', EN: 'Price ($/kWh)'},
      //labelFieldOptionHoraire: {FR: 'Horaire', EN: 'Scheduled'},
      //labelFieldOptionTemperature: {FR: 'Température', EN: 'Temperature'},
      //labelFieldTitleStartMonth: {FR: 'Mois début', EN: 'Start month'},
      //labelFieldTitleEndMonth: {FR: 'Mois fin', EN: 'End month'},
      //labelFieldTitleStartDay: {FR: 'Jour début', EN: 'Start day'},
      //labelFieldTitleEndDay: {FR: 'Jour fin', EN: 'End day'},
      //labelFieldTitleStartHour: {FR: 'Heure début', EN: 'Start hour'},
      //labelFieldTitleEndHour: {FR: 'Heure fin', EN: 'End hour'},
      //labelFieldOptionUnder: {FR: 'Inférieur à:', EN: 'Under:'},
      //labelFieldOptionOver: {FR: 'Supérieur à:', EN: 'Over:'},
      //labelFieldTitleTempThld: {FR: 'Température seuil (C)', EN: 'Threshold température (C)'},
      //labelFieldButtonDelete: {FR: 'Supprimer', EN: 'Delete'},
      //labelFieldButtonAddCond: {FR: 'Ajouter une condition au plan', EN: 'Add billing plan condition'},
      //labelField: {FR: '', EN: ''},
      labelFieldButtonConfirmDeleteDevice: {FR: "Supprimer le module", EN: 'Delete module'},
      labelFieldButtonConfirmSaveDevice: {FR: "Sauvegarder les paramètres du module", EN: 'Save module parameters'},

      textLabelReferenceName: {FR: "Nom de référence", EN: 'Referencen name'},
      textLabelModuleName: {FR: "Nom du module", EN: 'Module name'},
      textLabelModuleID: {FR: "Identifiant du module", EN: 'Module ID'},
      textLabelModuleSN: {FR: "Numéro de série", EN: 'Serial number'},


      sectionLabelApiDev: {FR: "Parametres de contrôle", EN: 'Control parameters'},
      sectionLabelApiDevCtrlParamID: {FR: "Paramètre", EN: 'Parameter'},
      sectionLabelApiDevCtrlValue: {FR: "Valeur", EN: 'Value'},
      sectionLabelApiDevCtrlLastValue: {FR: "Dernière transmise", EN: 'Last transmit'},
      sectionLabelApiDevTTLRaw: {FR: "Données brutes", EN: 'RAW data'},
      sectionLabelApiDevTTLHr: {FR: "Données aux heures", EN: 'Hourly data'},
      sectionLabelApiDevTTLDay: {FR: "Données aux journée", EN: 'Daily data'},

      //sectionLabelPortConfiguration:{FR: "Configuration des ports de mesure", EN: 'Measurement port configuration'},
      //tableLabelSensorFactor:{FR: "Facteur de multiplication du capteur", EN: 'Sensor multiplication factor'},
      //tableLabelCircuitVoltage:{FR: "Tension du circuit", EN: 'Circuit voltage'},
      //tableLabelAvrPowerFactor:{FR: "Facteur de puissance moyen", EN: 'Power factor (average)'},
      sectionLabelLocalisation:{FR: "Localisation du module", EN: 'Module location'},

      sectionLabelLinkedChannel:{FR: "Appareils liés au module", EN: 'Linked devices to this module'},

      //tableLinkedChannelChannelName:{FR: "Nom d'appareil", EN: 'Device name'},
      //tableLinkedChannelUserOrg:{FR: "Utilisateur/Organisation", EN: 'User/Organization'},
      //tableLinkedChannelBundle:{FR: "Nom du système", EN: 'System name'},
      //tableLinkedChannelPort:{FR: "Ports", EN: 'Ports'},

      messageRemoveDevice:{FR: "ATTENTION : La supression d'un module dont vous êtes propriétaire supprime automatiquement les partages et les appareils et alertes liés a ces partages! Si ce module provient d'un partage il sera uniquement retiré de votre système.",
                              EN: 'WARNING : The module deletion that you are owner will automatically delete all sharings and all device and alert linked to these sharings! If this module comes from a sharing, it will be only removed from your system.'},
      messageRemoveConfirmA:{FR: "Confirmer la supression du module : ", EN: 'Confirm module deletion : '},
      messageRemoveConfirmB:{FR: "Confirmer en écrivant : DELETE", EN: 'Confirm by writing : DELETE'},
      messagePostFail:{FR: "Une erreur est survenue pendant l'opération.", EN: 'An error occurs during the operation'},

      deviceConfigViewFlag : false,
      deviceConfigEditFlag : false,
      deviceConfigDeleteFlag : false,
      deviceSharingEnableFlag : false,

      bundleConfigEditFlag : false,

    }
  },
  computed: {
    ...mapState('sessionStore', ['profileData','displayAdminFlag','actualBundle']),
    ...mapState('overlayStore', ['overlayParameters']),
  },
  watch: {
    actualBundle(){
        this.reloadTempoBundle()
    },
  },

  methods: {
  ...mapActions('overlayStore', ['showModal']),

   toggleDisplayDevice(){
      this.flagDisplayDevice = ~this.flagDisplayDevice
    },

    reloadTempoBundle(){
        this.tempoBundle = JSON.parse(JSON.stringify(this.actualBundle))
    },

    togglePlanMap(){
      this.flagDisplayMap = ~this.flagDisplayMap
    },

    togglePortCfg(){
      this.flagDisplayPortCfg = ~this.flagDisplayPortCfg
    },

    toggleApiDevConfig(){
      this.flagDisplayApiDevConfig = ~this.flagDisplayApiDevConfig
    },


    toggleListOfChannel(){
      this.flagDisplayListOfChannel = ~this.flagDisplayListOfChannel
      if(this.flagDisplayListOfChannel==-1){this.getDeviceListOfLinkedChannels()}
    },


    usePlace(place) {
      let newLat = place.geometry.location.lat()
      let newLng = place.geometry.location.lng()
      this.center = {lat: newLat, lng: newLng}
      this.place = place
      this.locationString = place.formatted_address
      this.markers= [{
        position: {
          lat: newLat,
          lng: newLng,
        }
      }]
      this.tempoBundle.devices[this.deviceIndex].DeviceData.deviceInfo.latitude  = newLat
      this.tempoBundle.devices[this.deviceIndex].DeviceData.deviceInfo.longitude = newLng
      this.tempoBundle.devices[this.deviceIndex].DeviceData.deviceInfo.adress = place.formatted_address
      this.place = null;
    },

    saveDeviceModifications() {
        //Copie de DevicePlan dans tempoBundle puisque le component change le actualBundle
        this.tempoBundle.devices[this.deviceIndex].DeviceData.deviceInfo.pricingPlan = this.actualBundle.devices[this.deviceIndex].DeviceData.deviceInfo.pricingPlan
        this.deviceIsSaving = true
        var requestData = { 'postAction':'SaveDeviceModification',
                            'bundleId': this.tempoBundle.bundle_id,
                            'deviceIndex': this.deviceIndex,
                            'deviceData':JSON.parse(JSON.stringify(this.tempoBundle.devices[this.deviceIndex]))
                            }
        //console.log(requestData)      
        this.$store.dispatch('sessionStore/postDevice', requestData)
            .then((response) => {
              console.log(response.data)
              this.deviceIsSaving = false
            if(response.data.Code=='OK'){
                //this.$store.dispatch('sessionStore/getGroupArborescence')
                this.$store.dispatch('sessionStore/reloadActualBundle')
                }
                else{ window.alert(this.messagePostFail[this.actualLanguage] )}
            })       
      
    },

    getDeviceListOfLinkedChannels() {
        //Copie de DevicePlan dans tempoBundle puisque le component change le actualBundle

        this.deviceLinkedChannelIsReading = true
        var requestData = { 'postAction':'GetDeviceListOfLinkedChannel',
                            'bundleId': this.tempoBundle.bundle_id,
                            'deviceId': this.tempoBundle.devices[this.deviceIndex].DeviceData.deviceId,
                            }
        //console.log(requestData)      
        this.$store.dispatch('sessionStore/postDevice', requestData)
            .then((response) => {
              console.log(response.data)
              this.deviceLinkedChannelIsReading = false
            if(response.data.Code=='OK'){
                //this.$store.dispatch('sessionStore/getGroupArborescence')
                this.deviceListOfLinkedChannel = response.data.LinkedChannelList
                }
                else{ window.alert(this.messagePostFail[this.actualLanguage] )}
            })       
      
    },



    confirmRemoveDevice(){
          window.alert(this.messageRemoveDevice[this.actualLanguage])
          var confirmation = prompt(this.messageRemoveConfirmA[this.actualLanguage]+this.tempoBundle.devices[this.deviceIndex].ReferenceName, this.messageRemoveConfirmB[this.actualLanguage]);

          if(confirmation=='DELETE'){
              this.deviceIsDeleting = true
              var requestData = { 'postAction':'RemoveDeviceFromBundle',
                                  'deviceIndex':this.deviceIndex,
                                  'bundleId': this.tempoBundle.bundle_id,
                                  'deviceId': this.tempoBundle.devices[this.deviceIndex].DeviceData.deviceId,
                                  'parentContainer':this.parentContainer,
                                  }
              this.$store.dispatch('sessionStore/postBundle', requestData)
                  .then((response) => {
                    console.log(response.data)
                    this.deviceIsDeleting = false
                  if(response.data.Code=='OK'){
                      //this.$store.dispatch('sessionStore/getGroupArborescence')
                      this.$store.dispatch('sessionStore/reloadActualBundle')
                      this.alertShowAddButton=true
                      }
                      else{ window.alert(this.messagePostFail[this.actualLanguage] )}
                  })       
          }

    },


    shareEntity(){
      var modalParameters = {'modalTitle':{FR: "Partage de module", EN: 'Module sharing'},
                        'entityOwner':this.actualBundle.bundle_id,
                        'sharingType':'Device',
                        'entityId':this.tempoBundle.devices[this.deviceIndex].DeviceData.deviceId,
                        'entityReferenceName':this.tempoBundle.devices[this.deviceIndex].ReferenceName,
                        'displayAlertOptions':false,
                        'displayChannelOptions':false,
                        'displayDeviceOptions':true,
                        'displayBundleOptions':false,
                        'displayGroupOptions':false,
                        'displayUserOptions':false}

      this.$store.dispatch('overlayStore/setParameters',modalParameters)
      this.showModal('config-access-rules-form')
    },

    findPermissionItemValue(permissionList,idToFind){
        var value = false
        for (var n = 0; n < permissionList.length; n++){
          if(permissionList[n].id == idToFind)
          {value = permissionList[n].value
          //console.log('Value Found')
          }
        }
        return value
    },

  },

  mounted() {
    //Retirer l'inversion puisque le composant PortGraph effectue l'inversion sur la variable 
    //this.tableData = this.portData.reverse();
    //this.tableData = this.portData;
    //console.log('-----DEVICE DATA------')
    //console.log(this.tempoBundle.devices[this.deviceIndex])
    this.locationString = this.tempoBundle.devices[this.deviceIndex].DeviceData.deviceInfo.adress

    this.deviceConfigViewFlag = this.findPermissionItemValue(this.tempoBundle.devices[this.deviceIndex].DeviceData.permissions,'deviceConfigView')
    this.deviceConfigEditFlag = this.findPermissionItemValue(this.tempoBundle.devices[this.deviceIndex].DeviceData.permissions,'deviceConfigEdit')
    this.deviceConfigDeleteFlag = this.findPermissionItemValue(this.tempoBundle.devices[this.deviceIndex].DeviceData.permissions,'deviceConfigDelete')
    this.deviceSharingEnableFlag = this.findPermissionItemValue(this.tempoBundle.devices[this.deviceIndex].DeviceData.permissions,'deviceSharingEnable')

    this.bundleConfigEditFlag = this.findPermissionItemValue(this.actualBundle.permissions.bundle,'bundleConfigEdit')

    this.displayCloudLiveButton = this.tempoBundle.devices[this.deviceIndex].DeviceData.deviceInfo.model.includes('CM6')

    //Validation if the actual bundle is a bundle of the organization which create the device
    var DeviceCreatorOrganization = this.tempoBundle.devices[this.deviceIndex].DeviceData.deviceId.slice(0,5)
    this.flagBundleIsDeviceCreatorBundle = this.actualBundle.bundle_id.includes(DeviceCreatorOrganization)


    this.markers = [{
        position: {
          lat: this.tempoBundle.devices[this.deviceIndex].DeviceData.deviceInfo.latitude,
          lng: this.tempoBundle.devices[this.deviceIndex].DeviceData.deviceInfo.longitude,
        }
      }]
    this.center = {lat: this.tempoBundle.devices[this.deviceIndex].DeviceData.deviceInfo.latitude,
                   lng: this.tempoBundle.devices[this.deviceIndex].DeviceData.deviceInfo.longitude}

    if(localStorage.language){this.actualLanguage =  localStorage.language}
      else{this.actualLanguage = 'FR'}
  },

  beforeMount(){
    this.reloadTempoBundle()
  }

}
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// ConfigDeviceApiDevV1p00.vue?a69bee2c